import { Elements } from '@stripe/react-stripe-js';
import React, {useEffect} from "react";
import { useLocation } from "react-router-dom";
import { getOfferingCheckout } from 'util/api/CheckoutAPI';
import { StripeProvider } from 'react-stripe-elements';
import OfferingCheckout from 'components/OfferingCheckout';
import {useAuth} from 'util/auth'
import {useDispatch, useSelector} from 'react-redux'
import {loadPurchases} from 'store/actions/userActions'
import ChallengePageWidget from 'components/Challenges/ChallengePageWidget'
import {ProvideChallengeWidget, useChallenge} from 'util/challengeWidgetProvider'

import "pages/classWidget.scss";

// / A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ChallengeWidgetComponent(props) {
    const { match, stripe } = props;

    const challengeId = props.match.params.challengeId
    const auth = useAuth()

    const challenge = useChallenge()
    useEffect(() => {
        console.log("fetching challenge")
        getOfferingCheckout(challengeId)
            .then(data => {
                console.log("Offering data: ", data)
                if (data.offering) {
                    console.log("Challenge Offering: ", data.offering)
                    if (data.offering.bulletinBoardBodyHTML) {
                        console.log("setting 1")
                        challenge.setChallengeOffering({
                            ...data.offering,
                            bulletinBoardBodyHTML: data.offering.bulletinBoardBodyHTML.split('<a').join('<a target="_blank"')
                        })
                    } else {
                        console.log("setting 2")
                        challenge.setChallengeOffering(data.offering)
                    }
                }
            })
    }, [challengeId])

    
    const dispatch = useDispatch()

    let reservation_id = useQuery().get('reservation_id');

    const ownedOfferings = useSelector(state => state.user.ownedOfferings)
    const ownedChallenges = useSelector(state => state.user.ownedChallenges)

    console.log("Owned challegnes: ", ownedChallenges)

    useEffect(() => {
        if (auth.userData) {
            dispatch(loadPurchases(auth.userData))
        }
        
    }, [dispatch, auth.userData])

    useEffect(() => {
        const timer = setTimeout(() => {
            dispatch(loadPurchases(auth.userData))
        }, 2500);
        const timer2 = setTimeout(() => {
            dispatch(loadPurchases(auth.userData))
        }, 5000);
        return () => {
            clearTimeout(timer);
            clearTimeout(timer2);
        }
    }, [reservation_id]);
    
    return ( // JARCH
    <>

        {(ownedOfferings[challengeId] || ownedChallenges[challengeId]) ? (
        // {/* {true ? ( */}
            <ChallengePageWidget challengeid={challengeId} stripe={stripe} {...props}/>
        ) : (<>
            {reservation_id ? (
                <ChallengePageWidget challengeid={challengeId} stripe={stripe} {...props}/>
                // <PageLoader />
            ) : (
                <StripeProvider stripe={stripe} >
                    <Elements stripe={stripe} >
                        <OfferingCheckout challengeId={challengeId} {...props}/>
                    </Elements>
                </StripeProvider>
            )}
        </>)
        }
        
        
    </>
    )
}

function ChallengeWidget(props) {

    return (
        <ProvideChallengeWidget>
            <ChallengeWidgetComponent {...props}></ChallengeWidgetComponent>
        </ProvideChallengeWidget>
    )
}

export default ChallengeWidget;